export const initialFormData = {
    metro: {},
    user: {},
    store: {},
    include: {
        formAction: '',
        formProgress: '',
        //   leadsource: '',
        //   campaignId: '',
    },
};

export const initialUserData = {
    first_name: '',
    last_name: '',
    phone: '',
    email: '',
    description: '',
    //  updates: true,
};

export const FORM_ACTIONS = {
    question: 'Question',
    selfSchedule: 'Self Schedule',
};

export const FORM_PROGRESS = {
    initiateQuestion: 'Initiate Question',
    initiateSchedule: 'Initiate Schedule',
    selectLocation: 'Select Location',
};

// All three consult variants post an identical consultType, so they state which form they are and
// the handler maps it to a formType the rollout can gate. Must match FORM_SOURCE.consultation in
// functions/_utils/leads-capture-payload.js — an unrecognised value leaves the form on Pardot.
export const CONSULT_FORM_SOURCE = 'consultation';
